import React from "react";

import * as ResourceHub from "components/ResourceHub";

import * as styles from "./styles.module.scss";
import { ResourceHubPostProps } from "../Post";

type ResourceHubFeaturedBannerProps = {
  featuredPost: ResourceHubPostProps | null;
};

const FeaturedBanner: React.FC<ResourceHubFeaturedBannerProps> = ({ featuredPost }) => {
  return (
    <div className={styles.featuredBanner}>
      <div>{featuredPost && <ResourceHub.Post {...featuredPost} noLazyload={true} />}</div>
    </div>
  );
};

export default FeaturedBanner;
